import React from 'react';
import { connect } from 'react-redux';
import actions from 'actions/InCall/InCallVideo';
import Turtle from 'components/Turtle/Turtle';
import _get from 'lodash/get';
import { hooks, constants as c } from '@lifesize/clients.sdk';
import { DEFAULT_LEFT_BOUND, VIDEO_SECONDARY, VIDEO_PRIMARY } from 'constants/InCall/InCallVideo';
import { PropTypes as PT } from 'prop-types';

const mapActionCreators = (dispatch) => ({
  handleDrag: (e, ui) => dispatch(actions.handleDrag(e, ui)),
  turtleDragStart: () => dispatch(actions.turtleDragStart()),
  turtleDragStop: () => dispatch(actions.turtleDragStop())
});

const calculateTurtlePositionX = (containerWidth, videoLayout) => {
  const turtlePosition = containerWidth * videoLayout.splitPosition;
  const primaryVideoWidth = videoLayout?.videos?.videoPrimary?.width;

  if (turtlePosition > 0)
    if (primaryVideoWidth === 0) return videoLayout.rightBounds;
    // prevent turtle getting hidden on right side.
    else return turtlePosition;
  else return DEFAULT_LEFT_BOUND; // prevent turtle getting hidden on left side.
};

const mapStateToProps = (state, ownProps) => {
  const hasVideo =
    _get(state, 'app.inCallVideo.shouldDisplayPrimaryVideo') && _get(ownProps, 'remoteStreams.length', 0) > 0;
  const videoLayout = _get(state, 'app.inCallVideo.videoLayout') || {};

  const inlinePresentation =
    !!ownProps.remotePresentationStream && ownProps?.presentationLayout !== c.SFU_PRES_LAYOUT_POPPEDOUT;

  const positionX = _get(videoLayout, 'container.width') || 0;
  const turtlePosition = {
    x: calculateTurtlePositionX(positionX, videoLayout),
    y: videoLayout?.container?.height / 2
  };
  const isMinimized = _get(state, 'app.inCallVideo.isMinimized');
  const isDragging = _get(state, 'app.inCallVideo.isDragging');
  const visible = inlinePresentation && hasVideo && !isMinimized && ownProps.isTurtleVisible;

  return {
    turtlePosition,
    videoLayout,
    isDragging,
    visible,
    isWindowHidden:
      videoLayout?.videos?.[VIDEO_SECONDARY].width === 0 || videoLayout?.videos?.[VIDEO_PRIMARY].width === 0
  };
};

const ConnectedComponent = connect(mapStateToProps, mapActionCreators)(Turtle);

const FunctionalWrapper = (props, ref) => {
  const remoteStreams = hooks.useRemoteStreams();
  const remotePresentationStream = hooks.useRemotePresentationStream();
  const { presentationLayout } = hooks.useMedia();
  return (
    <ConnectedComponent
      {...props}
      remotePresentationStream={remotePresentationStream}
      remoteStreams={remoteStreams}
      presentationLayout={presentationLayout}
      ref={ref}
    />
  );
};

FunctionalWrapper.propTypes = {
  isTurtleVisible: PT.bool.isRequired
};

export default FunctionalWrapper;
